import ReactTooltip from 'react-tooltip';
import styled, { css } from 'styled-components';

export const SearchBar = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  span {
    color: var(--grey-300);
    font-size: 2rem;
    margin: auto 1.5rem;
    margin-bottom: 0.5rem;
  }
`

export const Input = styled.input`
  border-radius: 0.3125rem;
  padding: 0rem 1rem;
  margin: auto;
  background-color: var(--black-200);
  width: 100%;
  padding: 1rem;
  height: 3rem;
  font-family: Inter;

  &:focus {
    outline: 0;
  }
`

const buttonVariants = {
  exportButton: css`
  background: var(--black-300) !important;
  border-radius: 0.25rem;
  color: var(--white);
  transition: background 0.4s;
  margin-left: 1.5rem;
  img {
    width: 1.5rem;
    height: 1.5rem;
  }
  &:hover {
    background-color: darken(#3d3d3d, 10%);
  }
  `,
  disabledButton: css`
  `
}

type Props = {
  variants?: 'exportButton' | 'disabledButton'
}

export const Button = styled.button<Props>`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 1rem 1.25rem;
  width: 17%;
  height: 3rem;
  font-family: Inter;
  font-style: normal;
  font-weight: 600;
  font-size: 1rem;
  background-color: var(--primary);
  border-radius: 0.25rem;
  transition: filter 0.4s;
  ${({variants}) => variants ? buttonVariants[variants] : ''}

  &:hover {
    filter: brightness(70%);
  }
`

export const StyledReactTooltip = styled(ReactTooltip)`
  color: var(--white) !important;
  font-family: DM Sans;
  font-size: 1rem !important;
  width: 13.7rem;
  height: auto;
  opacity: 1 !important;
  margin-left: 20px !important;
`